module.exports = "/images/vendor/flag-icon-css/flags/1x1/ir.svg?7bf140ab46a7630cb7c40d6ef87cc4ba";